export const ArrowUpIcon = () => {
  return (
    <svg
      width="9"
      height="5"
      viewBox="0 0 9 5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M-1 5L4 0L9 5H-1Z" fill="#4CAF50" />
    </svg>
  );
};
